import Template from '../../component/Template.js';

import { useEffect, useState } from 'react';
import { useNavigate, useParams} from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function EditExpertCommitteeConvenor() {

  const [errors, setErrors] = useState({});
  const [expertCommitteeData, setExpertCommitteeData] = useState([]); 
  const { http } = Api();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [formData, setFormData] = useState({
      name: '',
      year: '',
      mobileNumber: '',
      email: '',
      expert_id: ''
    });
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/");
  }
 
  useEffect(() => {  
      if (isEdit) {
        loadConvenorDetails();
      }  
  }, [id]);  

  const loadConvenorDetails = async () => {
      try {  
        const res = await http.get(`/Admin/expert-committee-convenor/${id}`);  
        const data = res.data.data;  

        setFormData({  
          name: data.name,
          year: data.year,
          mobileNumber: data.mobile,
          email: data.email,
          expert_id: data.expert_id  
        });

      } catch (err) {
        console.error(err);
        toast.error("Failed to load convenor details");
      }
 };

   const handleInputChange = (e) => {

    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {

      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));

    }
  };  

  useEffect(() => {
    const getExpertCommitteeList = async () => {
      http.get('/Admin/expert-committee-convenor/getExpertCommitteeList')
        .then((response) => {
          setExpertCommitteeData(response.data.data);
        }).catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "An error occurred";
          if (status === 500 || error.response?.data?.status_code === "ERR5") {
            toast.error(message);
          } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/admin/"), 5000);
          } else {
            toast.error(message);
          }
        });
    };

    getExpertCommitteeList();
  }, []);
  const validateForm = () => {
    let hasError = false;
    let updatedErrors = {};
    if (!formData.expert_id) {
      updatedErrors.expert_id = 'Please select an Expert Committee Convenor.';
      hasError = true;
    }
    if (!String(formData.name || '').trim()) {
      updatedErrors.name = 'Name is required.';
      hasError = true;
    }

    if (!String(formData.year || '').trim()) {
      updatedErrors.year = 'Year is required.';
      hasError = true;
    }

    if (!String(formData.mobileNumber || '').trim()) {
      updatedErrors.mobileNumber = 'Phone Number is required.';
      hasError = true;
    }

    if (!String(formData.email || '').trim()) {
      updatedErrors.email = 'Email is required.';
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      updatedErrors.email = 'Enter a valid email address.';
      hasError = true;
    }   

    setErrors(updatedErrors);
    return !hasError;
  };


  const cancelForm = () => {
    window.location.reload();
  };

  const handlefirstsubmit = () => {
    if (validateForm()) {
      //e.preventDefault();
      const payloads = {
        expert_id: formData.expert_id || null,
        name: formData.name,
        year: formData.year,
        mobile: formData.mobileNumber,
        status: formData.status,
        email: formData.email
        
      };
      const request = isEdit
        ? http.put(`/Admin/expert-committee-convenor/${id}`, payloads)
        : http.post('/Admin/expert-committee-convenor', payloads);

      request.then((response) => {
        const isSuccess = response.data.status_code === 'MSG1' || response.data.status_code === 'MSG2';

        if (isSuccess) {
          toast.success(isEdit ? "Convenor details updated successfully" : "User data inserted successfully");
          setTimeout(() => {
            if (isEdit) {
              navigate('/admin/expertcommitteeconvenorlist');
            } else {
              cancelForm();
            }
          }, 3000);

        }
        else {
          toast.error(isEdit ? "Failed to update convenor details" : "Failed to save User Data");
        }
      }).catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/admin/"), 5000);
        } else {
          toast.error(message);
        }
      });
    }
    else {
      toast.error("Please fill mandatory fields");
    }
  };
  const handleExpertCommitteeChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      expert_id: selectedOption ? selectedOption.value : '',
    }));

    if (errors.expert_id) {
      setErrors((prev) => ({
        ...prev,
        expert_id: '',
      }));
    }
  };
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const currentYear = new Date().getFullYear();

  const yearOptions = [];
  for (let y = 2025; y <= currentYear; y++) {
    yearOptions.push(y);
  }

  return (
    <>
      <ToastContainer />
      <Template>


        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Edit Expert Committee Convenors</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="col-md-12 txt-aln pdg14">
                        <div className="row">
                          <div className="col">


                          
                              <div className="row ">
                                <label className="col-md-5 txt-aln-lft">Selected Expert Committee 
                                <span className="errorclr">*</span></label>
                                <div className="col-md-7 txt-aln-lft">

                                  <Select name='expert_id' 
                                    options={expertCommitteeData.map((item) => ({
                                      value: item.id,
                                      label: item.expert_committee_name,
                                    }))}
                                    value={expertCommitteeData
                                      .map((item) => ({ value: item.id, label: item.expert_committee_name }))
                                      .find((option) => String(option.value) === String(formData.expert_id)) || null}
                                    styles={customStyles}
                                    onChange={handleExpertCommitteeChange}
                                    placeholder="Select Expert Committee Convenor"
                                  />
                                   {errors.expert_id && <p className="text-danger">{errors.expert_id}</p>}
                                </div>                               
                              </div>
                            
             
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Name <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">
                                <input type="text" className="form-control input-air-primary" name="name" value={formData.name} onChange={handleInputChange}
                                />
                                {errors.name && <p className="text-danger">{errors.name}</p>}
                              </div>
                            </div>
                           
                            <div className="row">
                                  <label className="col-md-5 txt-aln-lft">
                                    Year <span className="errorclr">*</span>
                                  </label>
                                  <div className="col-md-7 txt-aln-lft">
                                    <select
                                      className="form-control input-air-primary"
                                      name="year"
                                      value={formData.year || ''}
                                      onChange={handleInputChange}
                                    >
                                      <option value="">Select Year</option>
                                      {yearOptions.map((y) => (
                                        <option key={y} value={y}>
                                          {y}
                                        </option>
                                      ))}
                                    </select>

                                    {errors.year && <p className="text-danger">{errors.year}</p>}
                                  </div>
                            </div>
                          
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Mobile Number <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">
                                <input type="text" className="form-control input-air-primary" name="mobileNumber" value={formData.mobileNumber} maxLength={11} inputMode="numeric" pattern="[0-9]{11}" onChange={handleInputChange}
                                />
                                {errors.mobileNumber && <p className="text-danger">{errors.mobileNumber}</p>}
                              </div>
                            </div>

                            {/* <div className="row">
                              <label className="col-md-5 txt-aln-lft">Landline Number</label>
                              <div className="col-md-7">
                                <input type="text" className="form-control input-air-primary" name="landlineNumber" value={formData.landlineNumber || ''} onChange={(e) => setFormData(prev => ({ ...prev, landlineNumber: e.target.value.replace(/[^0-9-]/g, '').slice(0, 13) }))} maxLength={13} inputMode="numeric" placeholder="e.g. 0481-2733309"
                                />
                                {errors.landlineNumber && <p className="text-danger">{errors.landlineNumber}</p>}
                              </div>
                            </div> */}
                          
                            <div className="row">
                              <label className="col-md-5 txt-aln-lft">Email <span className="errorclr">*</span></label>
                              <div className="col-md-7 txt-aln-lft">  
                                <input type="email" className="form-control input-air-primary" name="email" value={formData.email} onChange={handleInputChange}
                                />
                                {errors.email && <p className="text-danger">{errors.email}</p>}
                              </div>
                            </div>

                          </div>
                        </div>
                        <div>
                          <button className="btn btn-primary me-3" type="submit" onClick={handlefirstsubmit}>Submit</button>
                          <input className="btn btn-light" type="reset" style={{border:'2px solid black'}} value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
